import React, {useState} from 'react';
import { useTranslation } from 'react-i18next';


function LanguageSwitcher({mode=''}) {
    const { i18n } = useTranslation();
    const [open, setOpen] = useState(false);
    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
        localStorage.setItem('lang', lng);
        setOpen(false);
    };

    const currentLang = i18n.language;

    if(mode === 'dropdown') {
        const langs = {
            uz: "O‘zbekcha",
            ru: "Русский"
        };
        return (
            <div className="dropdown">
                <button
                    className="btn btn-outline-primary text-light dropdown-toggle"
                    type="button"
                    id="navbarDropdown"
                    aria-expanded={open ? "true" : "false"}
                    onClick={() => setOpen(!open)}
                    style={{border: "none"}}
                >
                    {langs[currentLang] || "Tilni tanlang"}
                </button>

                <ul
                    className={`dropdown-menu lang-dropdown dropdown-menu-end ${open ? "show" : ""}`}
                    aria-labelledby="navbarDropdown"
                >
                    {Object.entries(langs).map(([key, label]) => (
                        <li key={key}>
                            <span
                                className={`dropdown-item ${currentLang === key ? "active" : ""}`}
                                onClick={() => changeLanguage(key)}
                            >
                                {label}
                            </span>
                        </li>
                    ))}
                </ul>
            </div>
        );
    }

    return (
        <div>
            <button
                className={`btn btn-${currentLang === 'uz' ? '' : 'outline-'}primary`}
                onClick={() => changeLanguage('uz')}
                disabled={currentLang === 'uz'}
                style={{fontWeight: currentLang === 'uz' ? 'bold' : 'normal', marginRight: '10px'}}
            >
                O'zbek
            </button>
            <button
                className={`btn btn-${currentLang === 'ru' ? '' : 'outline-'}primary`}
                onClick={() => changeLanguage('ru')}
                disabled={currentLang === 'ru'}
                style={{fontWeight: currentLang === 'ru' ? 'bold' : 'normal'}}
            >
                Русский
            </button>
        </div>
    );
}

export default LanguageSwitcher;